<template>
  <v-btn @click="openCreateDefaultServiceValuesModal" color="primary" elevation="0">
    <v-icon left>mdi-plus</v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t(`create.label.defaultServiceValues`) }}
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'DefaultServiceValuesHeaderActions',

  methods: {
    openCreateDefaultServiceValuesModal() {
      const modal = this.$parent.$parent.$refs.financialRouterView.$refs.createDefaultServiceValues
      modal.openModal()
    }
  }
}
</script>
